import { render, staticRenderFns } from "./ClaimAddWalletDialog.vue?vue&type=template&id=05b55ab3&"
import script from "./ClaimAddWalletDialog.vue?vue&type=script&lang=js&"
export * from "./ClaimAddWalletDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports